/* Horizontal scroll stays inside the table so pages never scroll sideways on phones. */
.wrap {
  width: 100%;
  overflow-x: auto;
  background: var(--cl-card-bg);
  border: 1px solid var(--cl-card-border);
  border-radius: var(--cl-radius);
}

.table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  color: var(--cl-table-text);
  font-size: var(--cl-fs-base);
}

/* cl-thead-light: 12px uppercase #999 on #E4EAEE. */
.table th {
  height: 40px;
  padding: 0 10.5px;
  background: var(--cl-table-head-bg);
  color: var(--cl-table-head-text);
  font-size: var(--cl-fs-xs);
  font-weight: var(--cl-fw-regular);
  text-transform: uppercase;
  white-space: nowrap;
  border-bottom: 1px solid var(--cl-border-light);
}

.sticky th {
  position: sticky;
  top: 0;
  z-index: 1;
}

.table td {
  height: var(--cl-row-height);
  padding: 0 10.5px;
  border-bottom: 1px solid var(--cl-border-light);
  vertical-align: middle;
}

.dense td {
  height: var(--cl-row-height-compact);
}

.row:hover td {
  background: var(--cl-table-row-hover);
}

.row.selected td {
  background: var(--cl-info-tint-bg);
}

.clickable {
  cursor: pointer;
}

.left {
  text-align: left;
}

.right {
  text-align: right;
}

.center {
  text-align: center;
}

.selectCell {
  width: 46px;
  text-align: center;
}

.sortButton {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-transform: inherit;
  cursor: pointer;
}

.sortIcon {
  opacity: 0.35;
}

.sortActive {
  opacity: 1;
}

.emptyCell {
  color: var(--cl-text-muted);
  text-align: center;
}

.table .footerRow td {
  height: 42px;
  background: var(--cl-bg-row-colored);
  font-weight: var(--cl-fw-medium);
  border-bottom: 0;
}
